export default {
  ops: [
    { insert: '[Initiative title]\n', attributes: { header: 2 } },
    { insert: 'Product Requirement Document\n', attributes: { bold: true } },
    { insert: 'January 2025\n\n', attributes: { italic: true } },
    {
      insert:
        'Naming convention: YYMMDD_PRD_Initiative title [remove this after updating the name]\n\n',
    },
    { insert: 'Summary:\n', attributes: { header: 2 } },
    { insert: '[add a few sentences as summary]\n\n' },

    { insert: '1. Internal\n', attributes: { header: 2 } },
    {
      insert: 'What type of initiative is it?\n',
      attributes: { list: 'bullet' },
    },
    { insert: '\n' },
    {
      insert: 'Who are the key stakeholders?\n',
      attributes: { list: 'bullet' },
    },
    { insert: '\n' },
    {
      insert: 'Which team(s) will work on the initiative?\n',
      attributes: { list: 'bullet' },
    },
    { insert: '\n\n' },

    { insert: '2. Problem\n', attributes: { header: 2 } },
    { insert: 'What is the problem?\n', attributes: { list: 'bullet' } },
    { insert: '\n' },
    { insert: 'What do we want to achieve?\n', attributes: { list: 'bullet' } },
    { insert: '\n' },
    {
      insert: 'How will we measure success?\n',
      attributes: { list: 'bullet' },
    },
    { insert: '\n' },
    { insert: 'What is the current state?\n', attributes: { list: 'bullet' } },
    { insert: '\n' },
    {
      insert: 'Who are the primary users? And what are their needs?\n',
      attributes: { list: 'bullet' },
    },
    { insert: '\n' },
    {
      insert: 'What commercial value will this deliver?\n',
      attributes: { list: 'bullet' },
    },
    { insert: '\n' },
    {
      insert: 'What is the urgency for creating the solution?\n',
      attributes: { list: 'bullet' },
    },
    { insert: '\n\n' },

    { insert: '3. Solution\n', attributes: { header: 2 } },
    { insert: 'What is the ideal solution?\n', attributes: { list: 'bullet' } },
    { insert: '\n' },
    {
      insert: 'What are the high-level requirements for the solution?\n',
      attributes: { list: 'bullet' },
    },
    { insert: '\n' },
    {
      insert: 'What parts are must-have, nice to have, and out of scope?\n',
      attributes: { list: 'bullet' },
    },
    { insert: '\n' },
    {
      insert: 'How is the user going to use the solution? How do we know?\n',
      attributes: { list: 'bullet' },
    },
    { insert: '\n' },
    {
      insert:
        'How much effort will it take to develop the solution? (person weeks by role and team)\n',
      attributes: { list: 'bullet' },
    },
    { insert: '\n' },
    {
      insert:
        'What dependencies does the solution have with other initiatives?\n',
      attributes: { list: 'bullet' },
    },
    { insert: '\n' },
    {
      insert:
        'What do the operations of the solution look like? Is this scalable?\n',
      attributes: { list: 'bullet' },
    },
    { insert: '\n\n' },

    { insert: '4. Launch\n', attributes: { header: 2 } },
    {
      insert: 'What are the key development and release phases?\n',
      attributes: { list: 'bullet' },
    },
    { insert: '\n' },
    {
      insert:
        'How will we roll out the solution, and which stakeholders are involved?\n',
      attributes: { list: 'bullet' },
    },
    { insert: '\n\n' },

    { insert: '5. Glossary\n', attributes: { header: 2 } },
    { insert: '[Add glossary terms and their descriptions here.]\n\n' },

    { insert: '6. Appendix\n', attributes: { header: 2 } },
    {
      insert:
        '[You can add things here that don’t fit in the above structure, such as designs and/or links to other documents]\n',
    },
  ],
};
